import { render, staticRenderFns } from "./selectDataBank.vue?vue&type=template&id=d3c3c676&scoped=true"
import script from "./selectDataBank.vue?vue&type=script&lang=js"
export * from "./selectDataBank.vue?vue&type=script&lang=js"
import style0 from "./selectDataBank.vue?vue&type=style&index=0&id=d3c3c676&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c3c676",
  null
  
)

export default component.exports